import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/services/auth.services';

/**
 * Evita mostrar la pantalla de login cuando ya hay una sesión válida.
 * Si la sesión existe (o se pudo renovar con el refresh token), redirige
 * directamente al menú principal.
 */
@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);

  async canActivate(): Promise<boolean | UrlTree> {
    const authenticated = await this.authService.ensureAuthenticated();

    if (!authenticated) {
      return true;
    }

    return this.router.createUrlTree(['/menu']);
  }
}
